import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ChevronDown } from "lucide-react"; // Import ChevronDown icon from lucide-react or any other icon library

const options = [
  {
    lang: "pt",
    text: "PT",
  },
  {
    lang: "en",
    text: "EN",
  },
  {
    lang: "fr",
    text: "FR",
  },
];

const Selector = () => {
  const [t, i18n] = useTranslation("global");
  const storedLang = localStorage.getItem("selectedLang") || "en";
  const [selectedLang, setSelectedLang] = useState(storedLang);
  const [isOpen, setIsOpen] = useState(false);

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    setSelectedLang(lang);
    localStorage.setItem("selectedLang", lang);
    setIsOpen(false);
  };

  useEffect(() => {
    i18n.changeLanguage(selectedLang);
  }, [selectedLang, i18n]);

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between w-20 px-3 py-2 text-sm font-medium text-red-600 bg-[#F5F5F5] rounded-md focus:outline-none"
      >
        {options.find((option) => option.lang === selectedLang)?.text}
        <ChevronDown
          className={`ml-2 h-4 w-4 transition-transform ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>
      {isOpen && (
        <div className="absolute right-0 mt-2 w-20 bg-white rounded-md shadow-lg z-10">
          {options.map((option) => (
            <button
              key={option.lang}
              onClick={() => handleLanguageChange(option.lang)}
              className={`block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 ${
                selectedLang === option.lang ? "font-bold" : ""
              }`}
            >
              {option.text}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default Selector;
